import { render, staticRenderFns } from "./tanghuay.vue?vue&type=template&id=3ccfbad4&scoped=true&"
import script from "./tanghuay.vue?vue&type=script&lang=js&"
export * from "./tanghuay.vue?vue&type=script&lang=js&"
import style0 from "./tanghuay.vue?vue&type=style&index=0&id=3ccfbad4&scoped=true&lang=css&"
import style1 from "./tanghuay.vue?vue&type=style&index=1&id=3ccfbad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfbad4",
  null
  
)

export default component.exports